import { getLanguageTranslateList } from "@/api/index";

const state = {
  languageType: localStorage.getItem("language") || "中文",
  languageList: []
};

const mutations = {
  SET_LANGUAGE(state, language) {
    state.languageType = language;
    localStorage.setItem("language", language);
  },
  SET_LANGUAGE_LIST(state, list) {
    state.languageList = list;
  }
};

const actions = {
  async fetchLanguageList({ state, commit }) {
    if (state.languageList.length > 0) {
      return; // 如果 languageList 已经存在，直接返回，不再重复请求
    }
    try {
      const res = await getLanguageTranslateList();
      commit("SET_LANGUAGE_LIST", res.data);
    } catch (error) {
      console.error("Failed to fetch language list:", error);
    }
  },
  async setLanguage({ commit, dispatch }, language) {
    commit("SET_LANGUAGE", language); // 更新当前语言类型
    await dispatch("fetchLanguageList"); // 切换语言后重新加载翻译列表
  }
};

const getters = {
  getLanguageValue: (state) => (name) => {
    const language = (state.languageList || []).find(
      (item) =>
        item.languageCode === state.languageType && item.fieldName === name
    );
    return language ? language.translatedValue : name;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};